export default "__VITE_ASSET__CIiGJWx2__"